export enum CanvasActionType {
    EVENTNODE_ADD_ENDEVENT = 'eventnode:add:endEvent',
    EVENTNODE_ADD_INPRECURSOREVENT = 'eventnode:add:inPrecursorEvent',
    EVENTNODE_ADD_PIVOTALEVENT = 'eventnode:add:pivotalEvent',
    EVENTNODE_EDIT_ENDEVENT = 'eventnode:edit:endEvent',
    EVENTNODE_EDIT_INPRECURSOREVENT = 'eventnode:edit:inPrecursorEvent',
    EVENTNODE_EDIT_PIVOTALEVENT = 'eventnode:edit:pivotalEvent',
    EVENTNODE_EDIT_INITIATINGEVENT = 'eventnode:edit:initiatingEvent',

    EVENTNODE_COPY = 'eventnode:copy',
    EVENTNODE_DELETE = 'eventnode:delete',
    EVENTNODE_PASTE = 'eventnode:paste',
    EVENTNODE_REASSIGN_PARENT = 'eventnode:reassign:parent',
    EVENTNODE_FAULTTREE_ADD = 'eventnode:faultTree:add',
    EVENTNODE_FAULTTREE_COPY = 'eventnode:faultTree:copy',
    EVENTNODE_FAULTTREE_DELETE = 'eventnode:faultTree:delete',
    EVENTNODE_FAULTTREE_PASTE = 'eventnode:faultTree:paste',
    EVENTNODE_FAULTTREE_PROPERTIES = 'eventnode:faultTree:properties',
    FAULTTREENODE_ADD_COMPONENT = 'faultTreeNode:add:component',
    FAULTTREENODE_ADD_NODE = 'faultTreeNode:add:node',
    FAULTTREENODE_COPY_SUBTREE = 'faultTreeNode:copy:subTree',
    FAULTTREENODE_DELETE_NODE = 'faultTreeNode:delete:node',
    FAULTTREENODE_EDIT_NODE = 'faultTreeNode:edit:node',
    FAULTTREENODE_PASTE_SUBTREE = 'faultTreeNode:paste:subTree',
    FAULTTREENODE_PASTE_COMPONENT = 'faultTreeNode:paste:component',
    FAULTTREENODE_REORDER_CHILDREN = 'faultTreeNode:reorder:children',
    FAULTTREENODE_MINIMAL_CUT_SETS = 'faultTreeNode:minimalCutSets',
    FAULTTREENODE_CCF_ANALYSIS = 'faultTreeNode:ccfAnalysis',
    INCIDENT_DNA_CLEAR = 'incidentDNA:clear',
    INCIDENT_DNA_COMMENTS = 'incidentDNA:comments',
    INCIDENT_DNA_FAILURE = 'incidentDNA:failure',
    INCIDENT_DNA_OCCURRENCE_LIST = 'incidentDNA:occurrenceList',
    INCIDENT_DNA_PERFORMANCE_SHAPING_FACTORS = 'incidentDNA:performanceShapingFactors',
    INCIDENT_DNA_STATISTIC_SUMMARY = 'incidentDNA:statisticSummary',
    INCIDENT_DNA_STATISTICS = 'incidentDNA:statistics',
    INCIDENT_DNA_SUCCESS = 'incidentDNA:success',
    NODE_OCCURRENCE_LIST_PARAMS = 'node:occurrenceListParams',
    NODE_OCCURRENCE_LIST_VIEW = 'node:occurrenceListView',
    NODE_QUANTIFY_CHILDREN = 'node:quantify:children',
    NODE_QUANTIFY_BOTTOM_UP = 'node:quantify:bottomUp',
    NODE_QUANTIFY_TOP_DOWN = 'node:quantify:topDown',
    NODE_QUANTIFY_BOOTOM_UP_TO_HERE = 'node:quantify:bottomUpToHere',
    NODE_PROPERTIES = 'node:properties',
    NODE_TAGS = 'node:tags',
    NODE_PSF = 'node:psf',
    NODE_PSF_COUNTS = 'node:psf:counts',
    NODE_CFR_LOOKUP = 'node:cfr:lookup',

    NODE_ADD_CALLOUT = 'node:add:callout',
    NODE_EDIT_CALLOUT = 'node:edit:callout',
    NODE_DELETE_CALLOUT = 'node:delete:callout',

    CANVAS_ZOOM_IN = 'canvas:zoom:in',
    CANVAS_ZOOM_OUT = 'canvas:zoom:out',
    CANVAS_RECENTER = 'canvas:recenter',
    CANVAS_FIT_TO_VIEW = 'canvas:fitToView',
    CANVAS_FULLSCREEN = 'canvas:fullScreen',
    CANVAS_RELOAD_FT = 'canvas:reload:ft',
    CANVAS_SWITCH_FT_VIEW = 'canvas:switch:ftView',
    CANVAS_SEARCH = 'canvas:search',
    CANVAS_REDO = 'canvas:redo',
    CANVAS_UNDO = 'canvas:undo',
    CANVAS_TOGGLE_TAGS = 'canvas:toggle:tags',
    CANVAS_TOGGLE_CALLOUTS = 'canvas:toggle:callouts',
    CANVAS_REFRESH = 'canvas:refresh',
    CANVAS_TOGGLE_ODNA = 'canvas:toggle:odna',
    CANVAS_TOGGLE_DNA_LIST = 'canvas:toggle:odna:list',
    CANVAS_PULLED_ODNA = 'canvas:pulled:odna',
    CANVAS_PSF_TEMPLATE = 'canvas:psf:template',
    CANVAS_PSF_COUNTS = 'canvas:psf:counts',
    CANVAS_ODNA_STATS = 'canvas:odna:stats',
    CANVAS_ODNA_CLEAR_STATS = 'canvas:odna:clear:stats',
    CANVAS_CLEAR_ODNA = 'canvas:clear:odna',
    CANVAS_CLEAR_PSF = 'canvas:clear:psf',
    CANVAS_SAVE_ODNA = 'canvas:save:odna',
    CANVAS_STATUS_CHANGE_ODNA = 'canvas:statusChange:odna',

    CANVAS_IRP_SELECT = 'canvas:irp:select',

    SANITIZE_EVENT_SEQUENCE = 'sanitize:eventSequence',
    SANITIZE_OCCURRENCE_DNA = 'sanitize:occurrenceDNA',
    EVENT_SEQUENCE_SENSITIVITY_ANALYSIS = 'eventSequence:sensitivityAnalysis',
    EVENT_SEQUENCE_UNCERTAINTY_ANALYSIS = 'eventSequence:uncertaintyAnalysis',
    /** Opens the Model Testing modal on the Test Report tab (deep link). */
    TEST_REPORT_MAPPING = 'test:reportMapping',
    /** Opens the Model Testing modal (Review / Test Report / Shakedown tabs). */
    MODEL_TESTING = 'test:modelTesting',
    UNKNOWN = 'unknown',
}

export interface QueryCanvasAction {
    actionType: CanvasActionType;
    query?: any;   // used meanly for search
}